export default __webpack_public_path__ + "static/media/pastillas.10111c78.png";